import { faceplateClass } from "@/lib/theme";

const timeAgo = (iso) => new Date(iso).toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });

export const RecentList = ({ history = [], faceplate }) => (
  <section className="rise" style={{ animationDelay: "0.15s" }}>
    <h3 className="section-title">~ recently played ~</h3>
    {history.length === 0 && <p className="text-sm text-center" style={{ color: "var(--t-muted)" }} data-testid="public-player-recent-empty">nothing played yet</p>}
    <ol className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3" data-testid="public-player-recent-tracks-list">
      {history.map((h, i) => (
        <li key={h.id} className={`car-deck ${faceplateClass(faceplate)} rounded-xl p-2 min-w-0`} data-testid={`recent-track-${i}`}>
          <div className="flex items-center gap-2 px-1 pb-1.5">
            <span className="font-mono text-[0.55rem] tracking-[0.25em] deck-legend">TRK {String(i + 1).padStart(2, "0")}</span>
            <div className="deck-slot flex-1 h-1.5 rounded-full" aria-hidden />
            <span className="font-mono text-[0.55rem] tracking-[0.2em] deck-legend">{timeAgo(h.played_at)}</span>
          </div>
          <div className="lcd deck-lcd rounded-md px-3 py-2 min-w-0">
            <p className="font-display text-lg leading-tight truncate candy-text">{h.title}</p>
            <p className="font-mono text-[0.65rem] truncate lcd-text opacity-75">{h.artist || "unknown artist"}</p>
          </div>
        </li>
      ))}
    </ol>
  </section>
);
